import { styled } from "baseui";

export const FieldLabel = styled("div", ({ $theme }) => ({
  ...$theme.typography.font350,
}));
